import { createTheme } from '@mui/material/styles'

export const lightTheme = createTheme({
    spacing: [0, 4, 8, 16, 32, 64],
    palette: {
        mode: 'light',
        background: {
            default: '#F8FAFF',
        },
        customBackground: {
            default: '#FFFFFF',
        },
        success: {
            main: '#CBFBBF',
        },
        info: { main: '#E6F3FA' },
        orderState: {
            default: '#F5F5F5',
            offerRejected: '#ED6C024D',
            finished: '#42A5F5',
            offerAccepted: '#2CD36F',
            offerSent: '#FFA726',
            asked: '#4283ed',
        },
        tableHeader: {
            default: '#E7EBF4',
        },
        tableRow: {
            background: { paid: '#F2FFF7', notPaid: '#FFF2F2', offerSent: '#fffef0', oderAccepted: '#e0ffdd', asked: '#eaefff' },
        },
        customColor: { main: '#E7EBF4', light: '#bc75eb', dark: '#530c82', contrastText: 'white' },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
    },
})

export const darkTheme = createTheme({
    spacing: [0, 4, 8, 16, 32, 64],
    palette: {
        mode: 'dark',
        background: {
            default: '#121212',
        },
        customBackground: {
            default: '#000000',
        },
        success: { main: '#CBFBBF' },
        info: { main: '#E6F3FA' },
        orderState: {
            default: '#F5F5F5',
            offerRejected: '#ED6C024D',
            finished: '#42A5F5',
            offerAccepted: '#2CD36F',
            offerSent: '#FFA726',
            asked: '#4283ed',
        },
        tableHeader: {
            default: '#E7EBF4',
        },
        tableRow: {
            background: { paid: '#F2FFF7', notPaid: '#FFF2F2', offerSent: '#fffef0', oderAccepted: '#e0ffdd', asked: '#eaefff' },
        },
        customColor: { main: '#D3B7E5', light: '#dbc8e8', dark: '#c695e6', contrastText: 'black' },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
    },
})
